import {
  FantomSurvivorTabs,
  UndeadBlocksTabs,
  BigTimeTabs,
  MetaOpsTabs,
  EvIoTabs,
  MiniRoyaleNationsTabs,
  PlanetIXTabs,
  EarthFromAnotherSunTabs,
  ChronosTabs,
  BR1InfiniteTabs,
  RainiTheLordsOfLightTabs,
  CardsOfEthernityTabs,
  TheBornlessTabs,
  MokensLeagueTabs,
  SplinterlandsTabs,
  TheForgeArenaTabs,
  ChampionsAscensionTabs,
  PlanetMojoTabs,
  ReignOfTerrorTabs,
  ShrapnelTabs,
  WAGMIDefenseTabs,
  WorldWar0xTabs,
  DecentralGamesTabs,
  BattleForGiostoneTabs,
  TimeBreachersTabs,
  KittyKartTabs,
  UldorTabs,
  PulsarTabs,
  MightyActionHeroesTabs,
  SpiderTanksTabs,
  AxieInfinityOriginsTabs,
  AcryptiaTabs,
  WarsakenTabs,
  AvalonTabs,
  CritterCraftTabs,
  DarkCountryTabs,
  BlockchainBrawlersTabs,
  TheWakeRagnaroksLabyrinthTabs,
  CyberTitansTabs,
  CyBallTabs,
  MagicCraftTabs,
  ChesslersTabs,
  CitizenConflictTabs,
  BushiTabs,
  MirandusTabs,
  SuperiorTabs,
  RuneSeekerTabs,
  ChampionsArenaTabs,
  EternalParadoxTabs,
  KatanaInuTabs,
  LastExpeditionTabs,
  RageEffectTabs,
  StarfallArenaTabs,
  MechaWorldTabs,
  TollanWorldsTabs,
  LeagueOfLegendsTabs,
  SocialGamesTabs,
  CSGOTabs,
  GodsUnchainedTabs,
  FarcanaTabs,
  MetalCoreTabs,
  ComethBattleTabs,
} from '../../components/game-tabs';
import { Game } from 'functions/src/types/firestore/Game';
import { MintCardProps } from 'src/components/minting/MintCard';
import { MintDetailProps } from 'src/components/minting/MintDetail';
import { MintGuidePanelProps } from 'src/components/minting/MintGuidePanel';
import { Link } from 'src/components/Link';
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from 'src/config/firebaseClient';
import { CryptoChain } from '../CryptoChain';
import { Collection } from 'functions/src/types/firestore/Game/Collection';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';

const getGamesTabs = (
  openTabName: string,
  leaderboardFromQuery: string,
  title: string,
  id: string,
) => {
  switch (title) {
    case 'Undead Blocks':
      return (
        <UndeadBlocksTabs
          leaderboard={leaderboardFromQuery}
          openTabName={openTabName}
          title={title}
          id={id}
        />
      );
    case 'Fantom Survivor':
      return (
        <FantomSurvivorTabs openTabName={openTabName} title={title} id={id} />
      );
    // TODO: uncomment when mobile legends returns
    // case 'Mobile Legends':
    // return <MobileLegendsTabs openTabName={openTabName} id={id} />;
    case 'MetaOps':
      return <MetaOpsTabs openTabName={openTabName} id={id} />;
    case 'Big Time':
      return <BigTimeTabs openTabName={openTabName} id={id} />;
    case 'ev.io':
      return <EvIoTabs openTabName={openTabName} id={id} />;
    case 'Mini Royale:Nations':
      return <MiniRoyaleNationsTabs openTabName={openTabName} id={id} />;
    case 'Planet IX':
      return <PlanetIXTabs openTabName={openTabName} id={id} title={title} />;
    case 'Earth From Another Sun':
      return <EarthFromAnotherSunTabs openTabName={openTabName} id={id} />;
    case 'Chronos':
      return <ChronosTabs openTabName={openTabName} id={id} />;
    case 'BR1: Infinite':
      return <BR1InfiniteTabs openTabName={openTabName} id={id} />;
    case 'Raini:The Lords of Light':
      return <RainiTheLordsOfLightTabs openTabName={openTabName} id={id} />;
    case 'Cards Of Ethernity':
      return <CardsOfEthernityTabs openTabName={openTabName} id={id} />;
    case 'The Bornless':
      return <TheBornlessTabs openTabName={openTabName} id={id} />;
    case 'Mokens League':
      return <MokensLeagueTabs openTabName={openTabName} id={id} />;
    case 'Splinterlands':
      return <SplinterlandsTabs openTabName={openTabName} id={id} />;
    case 'The Forge Arena':
      return <TheForgeArenaTabs openTabName={openTabName} id={id} />;
    case 'Champions Ascension':
      return <ChampionsAscensionTabs openTabName={openTabName} id={id} />;
    case 'Planet Mojo':
      return <PlanetMojoTabs openTabName={openTabName} id={id} />;
    case 'Reign Of Terror':
      return <ReignOfTerrorTabs openTabName={openTabName} id={id} />;
    case 'SHRAPNEL':
      return <ShrapnelTabs openTabName={openTabName} id={id} />;
    case 'WAGMI Defense':
      return <WAGMIDefenseTabs openTabName={openTabName} id={id} />;
    case 'World War 0x':
      return <WorldWar0xTabs openTabName={openTabName} id={id} />;
    case 'Decentral Games':
      return <DecentralGamesTabs openTabName={openTabName} id={id} />;
    case 'Battle For Giostone':
      return <BattleForGiostoneTabs openTabName={openTabName} id={id} />;
    case 'Time Breachers':
      return <TimeBreachersTabs openTabName={openTabName} id={id} />;
    case 'KittyKart':
      return <KittyKartTabs openTabName={openTabName} id={id} />;
    case 'Uldor':
      return <UldorTabs openTabName={openTabName} id={id} />;
    case 'Pulsar':
      return <PulsarTabs openTabName={openTabName} id={id} />;
    case 'Mighty Action Heroes':
      return <MightyActionHeroesTabs openTabName={openTabName} id={id} />;
    case 'Spider Tanks':
      return <SpiderTanksTabs openTabName={openTabName} id={id} />;
    case 'Axie Infinity: Origins':
      return <AxieInfinityOriginsTabs openTabName={openTabName} id={id} />;
    case 'Acryptia':
      return <AcryptiaTabs openTabName={openTabName} id={id} />;
    case 'Warsaken':
      return <WarsakenTabs openTabName={openTabName} id={id} />;
    case 'Avalon':
      return <AvalonTabs openTabName={openTabName} id={id} />;
    case 'CritterCraft':
      return <CritterCraftTabs openTabName={openTabName} id={id} />;
    case 'Dark Country':
      return <DarkCountryTabs openTabName={openTabName} id={id} />;
    case 'Blockchain Brawlers':
      return <BlockchainBrawlersTabs openTabName={openTabName} id={id} />;
    case `The Wake: Ragnarok's Labyrinth`:
      return (
        <TheWakeRagnaroksLabyrinthTabs openTabName={openTabName} id={id} />
      );
    case 'CyberTitans':
      return <CyberTitansTabs openTabName={openTabName} id={id} />;
    case 'CyBall':
      return <CyBallTabs openTabName={openTabName} id={id} />;
    case 'MagicCraft':
      return <MagicCraftTabs openTabName={openTabName} id={id} />;
    case 'Chesslers':
      return <ChesslersTabs openTabName={openTabName} id={id} />;
    case 'Citizen Conflict':
      return <CitizenConflictTabs openTabName={openTabName} id={id} />;
    case 'Bushi':
      return <BushiTabs openTabName={openTabName} id={id} />;
    case 'Mirandus':
      return <MirandusTabs openTabName={openTabName} id={id} />;
    case 'Superior':
      return <SuperiorTabs openTabName={openTabName} id={id} />;
    case 'Rune Seeker':
      return <RuneSeekerTabs openTabName={openTabName} id={id} />;
    case 'Champions Arena':
      return <ChampionsArenaTabs openTabName={openTabName} id={id} />;
    case 'Eternal Paradox':
      return <EternalParadoxTabs openTabName={openTabName} id={id} />;
    case 'Katana Inu':
      return <KatanaInuTabs openTabName={openTabName} id={id} />;
    case 'Last Expedition':
      return <LastExpeditionTabs openTabName={openTabName} id={id} />;
    case 'Rage Effect':
      return <RageEffectTabs openTabName={openTabName} id={id} />;
    case 'Starfall Arena':
      return <StarfallArenaTabs openTabName={openTabName} id={id} />;
    case 'Tollan Worlds':
      return <TollanWorldsTabs openTabName={openTabName} id={id} />;
    case 'Mecha World':
      return <MechaWorldTabs openTabName={openTabName} id={id} />;
    case 'League Of Legends':
      return <LeagueOfLegendsTabs openTabName={openTabName} id={id} />;
    case 'Social Games':
      return <SocialGamesTabs openTabName={openTabName} id={id} />;
    case 'Counter-Strike: Global Offensive':
      return <CSGOTabs openTabName={openTabName} id={id} />;
    case 'Gods Unchained':
      return <GodsUnchainedTabs openTabName={openTabName} id={id} />;
    case 'Farcana':
      return <FarcanaTabs openTabName={openTabName} id={id} />;
    case 'MetalCore':
      return <MetalCoreTabs openTabName={openTabName} id={id} />;
    case 'Cometh Battle':
      return <ComethBattleTabs openTabName={openTabName} id={id} />;
    default:
      return null;
  }
};

export const getGameTabs = (
  game: Game<Date>,
  openTabName: string,
  leaderboardFromQuery: string,
) => {
  if (!game) {
    return null;
  }
  return getGamesTabs(openTabName, leaderboardFromQuery, game.title, game.id);
};

const getMintCards = async (id: string) => {
  const { docs } = await getDocs(
    collection(firestore, `Game/${id}/Collection`).withConverter(
      ConverterFactory.buildDateConverter<Collection<Date>>(),
    ),
  );
  const data = docs.map((doc) => {
    return doc.data();
  });
  return data.map((collectionData): MintCardProps => {
    const { title, contract, imgUrl } = collectionData;
    const { countMinted, countTotal, mintPrice, chainId } = contract!;
    return {
      collectionTitle: title,
      supplyMinted: countMinted,
      supplyTotal: countTotal,
      mintImage: imgUrl,
      unavailable: countTotal && countMinted >= countTotal,
      contractChainId: chainId,
      mintPrice: { price: mintPrice, currency: CryptoChain.from(chainId).coin },
    };
  });
};

export type MintGuideOptions = {
  mintCards: MintCardProps[] | [];
  mintDetails: MintDetailProps[] | [];
  mintGuide: MintGuidePanelProps;
  dates: {
    startDate: Date;
    endDate: Date | undefined;
  };
};

export const getMintGuideOptions = async (
  id: string,
): Promise<MintGuideOptions> => {
  switch (id) {
    case 'fantom-survivor':
      return {
        mintCards: await getMintCards(id),
        mintDetails: [
          {
            detailTitle: 'SURVIVORS GEN 1',
            detailContent:
              'Gen 1 Fantom Survivors launched on the Fantom chain in early April 2022. Gen 1 is the alpha generation -- the first of the first, the original set of survivors -- having benefits and one-of-a-kind rarity not seen in subsequent generations.',
          },
          {
            detailTitle: 'SURVIVORS GEN 2',
            detailContent:
              'The Gen 2 Survivors are referred to as the Beta generation (no unique names nor special weapons like the Gen1). We launched 556 Survivors at 3 AVAX per Survivor. Gen 2 will be able to compete in weekly challenges against Gen 1 Survivors (Alpha generation), and prizes will be rewarded relevant to the chain the survivor is from.',
          },
        ],
        mintGuide: {
          steps: [
            'Create a MetaMask wallet.',
            'Connect to blumint.com using your MetaMask wallet.',
            'Choose the collection that you would like to mint.',
            'Confirm & sign the transaction. You will need some AVAX/FTM for gas.',
            <>
              Once the transaction is complete, your newly generated weapon
              loadout will appear in your <Link href="/profile">inventory</Link>
              .
            </>,
          ],
        },
        dates: {
          startDate: new Date('April 5, 2022'),
          endDate: undefined,
        },
      };
    default:
      return {
        mintCards: [],
        mintDetails: [],
        mintGuide: {
          steps: [],
        },
        dates: {
          startDate: new Date(),
          endDate: undefined,
        },
      };
  }
};
